import { Injectable, Injector, ViewContainerRef, createNgModule } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SmallLazyLoadingService {
  public mainContainerRef: ViewContainerRef;
  constructor(
    private readonly injector: Injector
  ) { }
  public setMainContainerRef(mainContainerRef: ViewContainerRef) {
    this.mainContainerRef = mainContainerRef;
  }

  async loadMainModule() {
    console.log("loadMainModule");
    try {
      await this.loadScript('assets/js/jquery-3.7.0.min.js');

      const { MainModule } = await import("../main.component");
      const moduleRef = createNgModule(MainModule, this.injector);
      const componentFactory = moduleRef.instance.getComponent();
      this.mainContainerRef.clear();
      this.mainContainerRef.createComponent(componentFactory, { ngModuleRef: moduleRef });
    } catch (err) {
      console.log("err in loadMainModule", err);
    }
  }

  async loadVoiceSelection() {
    localStorage.setItem('pw-voice-select', 'true');
    const { VoiceSelectionModule } = await import("../voice-selection-module/voice-selection.component");
    const moduleRef = createNgModule(VoiceSelectionModule, this.injector);
    const componentFactory = moduleRef.instance.getComponent();
    this.mainContainerRef.clear();
    this.mainContainerRef.createComponent(componentFactory, { ngModuleRef: moduleRef });
  }

  public read<T>(key: string): T {
    const value: string = localStorage.getItem(key);
    let res = null;
    if (value && value !== 'undefined' && value !== 'null') {
      try {
        res = <T>JSON.parse(value);
      } catch {
        res = value;
      }
    }

    return res;
  }

  public loadScript(_url: string) {
    return new Promise((resolve, reject) => {
      if (this.isInclude(_url, true)) {
        resolve(null);
      } else {
        var element = document.createElement("script");
        var parent = 'body';
        element.type = "text/javascript";
        element.src = _url;
        element.async = true;
        element.onload = function() {
          console.log("loadedScript", _url);
          resolve(null);
        };
        element.onerror = function(err) {
          console.log("err loadScript", err);
          reject(err);
        };
        document[parent].appendChild(element);
      }
    });
  }
  private isInclude(name, isScript) {
    let names = name.split('/');
    if (names.length > 0) {
      name = names[names.length - 1];
    }
    let es = document.getElementsByTagName(isScript ? 'script' : 'link');
    for (let i = 0; i < es.length; i++)
      if (typeof (es[i][isScript ? 'src' : 'href']) !== 'undefined') {
        if (es[i][isScript ? 'src' : 'href'].indexOf(name) != -1) return true;
      }
    return false;
  }
}
